// CARTON QUANTITY — hide add to cart if carton quantity is 0 or 1

function checkCartonQuantity() {
    const detailItems = document.querySelectorAll('li.sf-book-details__custom');
    if (!detailItems.length) return false;

    const cartonItem = Array.from(detailItems).find(li => {
        const strong = li.querySelector('strong');
        return strong && strong.textContent.trim().toLowerCase().startsWith('carton quantity');
    });

    if (!cartonItem) return false;

    const fullText = cartonItem.textContent || '';
    const strongEl = cartonItem.querySelector('strong');
    const valueText = strongEl
        ? fullText.replace(strongEl.textContent, '').trim()
        : fullText.trim();

    const quantity = parseInt(valueText, 10);

    if (quantity === 0 || quantity === 1) {
        const addToCartWrapper = document.querySelector('.lightly-spaced-row.not-in-quickbuy');
        if (!addToCartWrapper) return false;

        addToCartWrapper.style.display = 'none';

        if (!document.querySelector('#sf-digital-only-message')) {
            const msgContent = `
                <p id="sf-digital-only-message" style="padding: 12px 0; font-size: 17px;">
                    <strong>Available through ebook retailers and used bookstores</strong>
                </p>
            `
            addToCartWrapper.insertAdjacentHTML('afterend', msgContent);
        }
    }

    return true;
}

if (!checkCartonQuantity()) {
    const cartonObserver = new MutationObserver(() => {
        if (checkCartonQuantity()) {
            cartonObserver.disconnect();
        }
    });

    cartonObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
}


// AUTHOR BIO IMAGE REPLACEMENT — only runs for specific product IDs

function replaceAuthorImage() {
    const img = document.querySelector('.author-bios img');
    if (img) {
        img.src = "https://cdn.shopify.com/s/files/1/0627/8532/3085/files/Gregoire_Sheila_Wray.jpg?v=1776674741";
        img.srcset = "";
        return true;
    }
    return false;
}

const allowedIds = [7490359984205, 7490354937933];

if (window.productData && allowedIds.includes(window.productData.id)) {
    if (!replaceAuthorImage()) {
        const imageObserver = new MutationObserver(() => {
            if (replaceAuthorImage()) {
            imageObserver.disconnect();
            }
        });

        imageObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
}